import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, useNavigate, useLocation } from 'react-router-dom';
import { auth } from './firebase'; // Import Firebase auth
import { onAuthStateChanged } from 'firebase/auth';
import './App.css';
import Header from './components/Header';
import Footer from './components/Footer';
import HomePage from './pages/HomePage.js';
import ServicesPage from './pages/ServicesPage.js';
import AboutUsPage from './pages/AboutUsPage.js';
import ContactUsPage from './pages/ContactUsPage.js';
import Login from './components/Login';
import ProductDetailsPage from './pages/ProductDetailsPage';
import WhatsAppWidget from './components/WhatsAppWidget';

import PaymentStatusPage from './pages/PaymentStatusPage.js';
import RefundPolicyPage from './pages/RefundPolicyPage.js';
import PrivacyPolicyPage from './pages/PrivacyPolicyPage.js';
import TermsOfServicePage from './pages/TermsOfServicePage.js';
import ShippingPolicyPage from './pages/ShippingPolicyPage.js';

import useScrollToTop from './hooks/useScrollToTop.js';
import { AnimatePresence } from 'framer-motion';

function App() {
  useScrollToTop();
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, (user) => {
      if (user) {
        setIsAuthenticated(true);
      } else {
        setIsAuthenticated(false);
      }
    });

    return () => unsubscribe();
  }, []);

  const handleLoginSuccess = () => {
    setIsAuthenticated(true);
    navigate('/');
  };

  const handleLogout = () => {
    auth.signOut().then(() => {
      setIsAuthenticated(false);
      navigate('/login');
    });
  };

  return (
    <div className="flex flex-col min-h-screen">
      <Header isAuthenticated={isAuthenticated} onLogout={handleLogout} />
      <main className="flex-grow">
        <AnimatePresence mode="wait">
          <Routes location={location} key={location.pathname}>
            <Route path="/" element={<HomePage />} />
            <Route path="/services" element={<ServicesPage />} />
            <Route path="/about" element={<AboutUsPage />} />
            <Route path="/contact" element={<ContactUsPage />} />

            <Route path="/payment-status" element={<PaymentStatusPage />} />
            <Route path="/refund-policy" element={<RefundPolicyPage />} />
            <Route path="/privacy-policy" element={<PrivacyPolicyPage />} />
            <Route path="/terms-of-service" element={<TermsOfServicePage />} />
            <Route path="/shipping-policy" element={<ShippingPolicyPage />} />

            <Route path="/login" element={<Login onLoginSuccess={handleLoginSuccess} />} />
            <Route path="/product/:id" element={<ProductDetailsPage />} />
          </Routes>
        </AnimatePresence>
      </main>
      <Footer />
      <WhatsAppWidget />
    </div>
  );
}

function AppWrapper() {
  return (
    <Router>
      <App />
    </Router>
  );
}

export default AppWrapper;
